module.exports = __webpack_public_path__ + "static/media/asc-street-selected.8bfc800c.svg";